<template>
	
	<v-card class="pa-2">
		<v-form>
			<p class="overline">Payment Method</p>
			<v-btn-toggle color="primary" v-model="details.paymentMethod">
				<v-btn value="cheque">Cheque</v-btn>
				<v-btn value="bankTransfer">Bank Transfer</v-btn>
				<v-btn value="amazonVoucher">Amazon Voucher</v-btn>
			</v-btn-toggle>
			<v-row v-if="details.paymentMethod == 'bankTransfer' || paymentMethod == 'cheque'">
				<v-col>
					<v-text-field :label="nameLabel" v-model="details.name"></v-text-field>
				</v-col>
			</v-row>
			<v-row v-if="details.paymentMethod == 'cheque'"> 
				<v-col>
					<v-text-field label="Address" v-model="details.address"></v-text-field>
				</v-col>
			</v-row>
			<v-row v-if="details.paymentMethod == 'amazonVoucher'"> 
				<v-col>
					<v-text-field label="Email Address For Voucher" v-model="details.email"></v-text-field>
				</v-col>
			</v-row>
			<v-row v-if="details.paymentMethod == 'cheque'"> 
				<v-col cols="12" sm="8">
					<v-text-field label="City / Town / County" v-model="details.city"></v-text-field>
				</v-col>
				<v-col>
					<v-text-field label="Post Code" v-model="details.postcode"></v-text-field>
				</v-col>
			</v-row>
			<v-row v-if="details.paymentMethod == 'bankTransfer'"> 
				<v-col>
					<v-text-field label="Sort Code" v-model="details.sortCode"></v-text-field>
				</v-col>
				<v-col>
					<v-text-field label="Account Number" v-model="details.accountNumber"></v-text-field>
				</v-col>
			</v-row>
			<p v-if="details.paymentMethod == 'bankTransfer'">
				<b>Why do I have to provide these details again?</b><br/>
				For your security, bank details are kept on our database only until the payment is made
			</p>
		</v-form>
	</v-card>
</template>
<script>
	export default{
		name: "IncentiveForm", 
		// data: () => {
		// 	return {
		// 		paymentMethod: "", 
		// 		sortCode: "", 
		// 		accountNumber: "", 
		// 		name: "", 
		// 		email: "",
		// 		address: ""
		// 	}
		// }, 
		props: ["details"],
		computed: {
			nameLabel(){
				return this.details.paymentMethod == "cheque" ? "Name as you would like it to appear on the cheque" :  this.paymentMethod == "bankTransfer" ? "Name associated with bank account" : "Your name"
			}
		},
		methods: {

		}

	}
</script>